export const BASE_TAB_ID = 'change-log-history-filter-tab';
